import React, { Component } from 'react';
// import './App.css';
import {  ACCESS_TOKEN } from '../constants';
import GCMap from "../map/GCMap";
import TripList from './TripList';
import { getTrips, loadCurrentlyLoggedInUser } from '../util/APIUtils';
import Alert from 'react-s-alert';
// import GCServer from './server/GCServer';
// import AuthenticationService from './server/AuthenticationService ';




class SatApp extends Component {
    constructor(props) {
        console.log('mainapp constructor');
        super(props);
        this.state = { trips: [] };
    }

    componentDidMount() {
        console.log('loading trips');
        const tripRequest = Object.assign({}, this.state);
        var user = this.props.currentUser;
        // getTrips(tripRequest, user.id)
        // .then(response => {
        //     // localStorage.setItem(ACCESS_TOKEN, response.accessToken);
        //     // Alert.success("You're successfully logged in!");
        //     this.setState({ trips: response });
        //     // this.props.history.push("/");
        // }).catch(error => {
        //     Alert.error((error && error.message) || 'Oops! Something went wrong. Please try again!');
        // });
    }

    render() {
        console.log('redering Mainapp');
        return (
            <div>
                <GCMap trips={this.state.trips} />
                {/* <TripList trips={this.state.trips} /> */}
            </div>
        )
    }
}

export default SatApp;

// export default function App() {
//   // return <SimpleExample />;
//   // return <MyMap />
//   return <OtherLayersExample />;
// }
